/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetModifiableMonthlyLimitsForTheUserAccount200Response
 */
export interface GetModifiableMonthlyLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum];


